/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { projectService } from '../services/api';
import { EmptyState, LinkButton, Page, PageHeader, Skeleton } from '../components/console/ui';
import { FolderIc } from '../components/console/icons';
import ProjectTeam from '../components/projects/ProjectTeam';

const ProjectSettings: React.FC = () => {
    const { id: projectId } = useParams<{ id: string }>();

    const { data: projectData, isLoading: projectLoading } = useQuery({
        queryKey: ['project', projectId],
        queryFn: () => projectService.get(projectId!).then((res) => res.data),
        enabled: !!projectId,
    });

    const project = projectData?.project || projectData;

    if (projectLoading) {
        return (
            <Page>
                <Skeleton className="h-9 w-64" />
                <Skeleton className="h-64 rounded-[14px]" />
            </Page>
        );
    }

    if (!project || !projectId) {
        return (
            <Page>
                <EmptyState
                    icon={<FolderIc />}
                    title="Project not found"
                    body="The project you're looking for doesn't exist or you no longer have access to it."
                    actions={<LinkButton to="/projects">Back to projects</LinkButton>}
                />
            </Page>
        );
    }

    return (
        <Page>
            <PageHeader
                back={{ to: `/projects/${projectId}`, label: project.name }}
                title="Team"
                subtitle="Manage who can access this project and what they can do."
            />
            <ProjectTeam projectId={projectId} ownerId={project.owner_id} />
        </Page>
    );
};

export default ProjectSettings;
